// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3ahNG","buttons":"PendingPaymentAlert_buttons__1OvAI"};